import cx from "classnames";
import { useTranslation } from "next-i18next";

import { ButtonBack, Text } from "@/components/elements";
import useGoBack from "@/hooks/useGoBack";

import { HeaderStyleProps } from "./Header";
import header from "./header.module.css";

type MinimalHeaderProps = {
  title: string;
  cta?: string;
} & HeaderStyleProps;

export const MinimalHeader = ({
  inverse,
  overlay,
  title,
  cta,
}: MinimalHeaderProps) => {
  const goBack = useGoBack();
  const { t } = useTranslation("header");

  return (
    <header
      className={cx(header.header, {
        [header.inverse]: inverse,
        [header.overlay]: overlay,
      })}
    >
      <ButtonBack
        onClick={() => goBack()}
        label={t("navigation.back")}
        copy={cta}
        className={header.back_button}
      />
      <Text as="h1" className={header.h1}>
        {title}
      </Text>
    </header>
  );
};
